export default {
    /* Plugins data */
    GET_PLUGINS_DATA: 'GET_PLUGINS_DATA',
    GET_PLUGINS_DATA_SUCCESS: 'GET_PLUGINS_DATA_SUCCESS',
    GET_PLUGINS_DATA_ERROR: 'GET_PLUGINS_DATA_ERROR',
  };
  


// WEBPACK FOOTER //
// ./src/constants/plugins/pluginsTypes.js